import * as React from 'react';
import * as _ from 'lodash-es';

import classNames from 'classnames';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import SvgIconSearch from '../../static/icons/svgIconSearch';
import SvgIconCreditCard from '../../static/icons/svgIconCreditCard';
import SvgIconSetting from '../../static/icons/svgIconSetting';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { TB_AGENCY_ID } from '../../configs/Api';
import { connectWithRouter, withRouterV6 } from 'helpers/connectWithRouter';
import { hasPermission } from 'helpers/Permission';
import { PermissionTypes, ResourceTypes } from '../../constants';

const styles = require('./styles.pcss');

class SidebarMenu extends React.Component<any, any> {
  handleNavigation = (path: string) => {
    this.props.navigate(path);
  };

  render() {
    const loginData = localStorage.getItem('login_data');
    let loginDataperse: any = null;

    if (loginData) {
      loginDataperse = JSON.parse(loginData);
    }

    return (
      <div className={styles.menu}>
        <List
          component="nav"
          className={classNames(styles.list)}
        >
          <ListItem
            className={
              window.location.pathname.includes('/lookup')
                ? classNames(styles.listItem, styles.active)
                : classNames(styles.listItem)
            }
          >
            <ListItemIcon className={styles.iconWrapper}>
              <SvgIconSearch
                width={14}
                height={14}
              />
            </ListItemIcon>
            <ListItemText
              primary="Lookup"
              className={classNames(styles.listItemText)}
              onClick={() => {
                this.handleNavigation(`/lookup`);
              }}
            />
          </ListItem>

          {(!_.get(loginDataperse, 'agencyId', false) ||
            _.get(loginDataperse, 'agencyId', false) == TB_AGENCY_ID) && (
            <ListItem
              className={
                window.location.pathname.includes('/refund-charge')
                  ? classNames(styles.listItem, styles.active)
                  : classNames(styles.listItem)
              }
            >
              <ListItemIcon className={styles.iconWrapper}>
                <SvgIconCreditCard
                  width={23}
                  height={14}
                />
              </ListItemIcon>
              <ListItemText
                primary="Refund/Charge Form"
                className={classNames(styles.listItemText)}
                onClick={() => {
                  this.handleNavigation(`/refund-charge`);
                }}
              />
            </ListItem>
          )}

          {(!_.get(loginDataperse, 'agencyId', false) ||
            _.get(loginDataperse, 'agencyId', false) == TB_AGENCY_ID) && (
            <ListItem
              className={
                window.location.pathname.includes('/manage-tb')
                  ? classNames(styles.listItem, styles.active)
                  : classNames(styles.listItem)
              }
            >
              <ListItemIcon className={styles.iconWrapper}>
                <SvgIconSetting
                  width={16}
                  height={16}
                />
              </ListItemIcon>
              <ListItemText
                primary="Manage TB"
                className={classNames(styles.listItemText)}
                onClick={() => {
                  this.handleNavigation(`/manage-tb`);
                }}
              />
            </ListItem>
          )}
          {hasPermission(ResourceTypes.auditEvents, PermissionTypes.read) && (
          <ListItem
            className={
              window.location.pathname.includes('/audit-events')
                ? classNames(styles.listItem, styles.active)
                : classNames(styles.listItem)
            }
          >
            <ListItemIcon className={styles.iconWrapper}>
              <ArticleOutlinedIcon className={styles.listIcon} />
            </ListItemIcon>
            <ListItemText
              primary="Audit Logs"
              className={classNames(styles.listItemText)}
              onClick={() => {
                this.handleNavigation(`/audit-events`);
              }}
            />
          </ListItem>
          )}
        </List>
      </div>
    );
  }
}

export default withRouterV6(SidebarMenu);
